import BC from '../init';

export default BC.Methods.overflowCalculate = ($this) => {
    const items = $this.querySelectorAll('.overflow-calc');

    const setWidth = () => {
        items.forEach(item => {
            const width = item.parentElement.offsetWidth;
            item.style.maxWidth = `${width - 1}px`;
            item.style.whiteSpace = 'nowrap';
        });
    }

    setWidth();

    window.addEventListener('resize', setWidth);
};
